module.exports = __webpack_public_path__ + "static/media/me.7d2ff237.JPG";